import { render, staticRenderFns } from "./ProductReportsDashboard.vue?vue&type=template&id=148f3982&scoped=true"
import script from "./ProductReportsDashboard.vue?vue&type=script&lang=js"
export * from "./ProductReportsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsDashboard.vue?vue&type=style&index=0&id=148f3982&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f3982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148f3982')) {
      api.createRecord('148f3982', component.options)
    } else {
      api.reload('148f3982', component.options)
    }
    module.hot.accept("./ProductReportsDashboard.vue?vue&type=template&id=148f3982&scoped=true", function () {
      api.rerender('148f3982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/ProductReportsDashboard.vue"
export default component.exports